import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient, HttpHeaders }from '@angular/common/http';
import { Account, PagedResponseAccount } from '../models/Account';
import { environment } from 'src/environments/environment';
import { PagedResponseKaizen, Kaizen } from './kaizen';


@Injectable({
  providedIn: 'root'
})

export class KaizenService 
{
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  getKaizens():Observable<PagedResponseKaizen>{
    const data =  this.http.get<PagedResponseKaizen>(this.APIURL+'/Kaizen' + '?PageNumber=1&PageSize=50&ShowHidden=true');
    this.messageService.add('Kaizen Service: fetched Kaizens include Hidden');
    
    return data;
  }

  getKaizensExcludeHidden():Observable<PagedResponseKaizen>{
    const data =  this.http.get<PagedResponseKaizen>(this.APIURL+'/Kaizen' + '?PageNumber=1&PageSize=50&ShowHidden=false');
    this.messageService.add('Kaizen Service: fetched Kaizen exclude Hidden');
    
    return data;
  }
  getKaizensExcludeHiddenPaged(pageNumber: number, pageSize: number): Observable<PagedResponseKaizen> {
    const url = `${this.APIURL}/Kaizen?PageNumber=${pageNumber}&PageSize=${pageSize}&ShowHidden=false`;
    this.messageService.add('Kaizen Service: fetched Kaizen exclude Hidden');
    console.log('url:', url);
    return this.http.get<PagedResponseKaizen>(url);
  }
  getKaizensByUser(useremail: string): Observable<PagedResponseKaizen> {
    // const data = this.http.get<PagedResponseKaizen>(this.APIURL + '/Kaizen/GetAllByUser/' + useremail);
    const data =  this.http.get<PagedResponseKaizen>(this.APIURL+'/Kaizen' + '?PageNumber=1&PageSize=55&ShowHidden=true&Email='+useremail);
    return data;
  }

  getKaizensByUserExcludeHidden(useremail: string): Observable<PagedResponseKaizen> 
  {
    // const data = this.http.get<PagedResponseKaizen>(this.APIURL + '/Kaizen/GetAllByUser/' + useremail);
    const data =  this.http.get<PagedResponseKaizen>(this.APIURL+'/Kaizen' + '?PageNumber=1&PageSize=55&ShowHidden=false&Email='+useremail);
    return data;
  }
  getKaizensByUserExcludeHiddenPaged(useremail: string, pageNumber: number, pageSize: number): Observable<PagedResponseKaizen> {
    const url = `${this.APIURL}/Kaizen` + `?PageNumber=${pageNumber}` + `&PageSize=${pageSize}` + `&ShowHidden=false` + `&Email=${useremail}`;
    this.messageService.add('Kaizen Service: fetched user Kaizens');
    console.log('url:', url);
    return this.http.get<PagedResponseKaizen>(url);
  }
  getKaizen(id: number): Observable<Kaizen> 
  {
    const Account =this.http.get<Kaizen>(this.APIURL+'/Kaizen/' + id);
    this.messageService.add(`Kaizen Service: fetched Kaizen with id=${id}`);
    return Account;
  }

  delKaizen(id: number): Observable<Kaizen> 
  {
    const Account =this.http.delete<Kaizen>(this.APIURL+'/Kaizen/' + id);
    this.messageService.add(`Kaizen Service: fetched Kaizen with id=${id}`);
    return Account;
  }

  searchKaizens(criteria:string, hidden: Boolean, email: string):  Observable<PagedResponseKaizen> 
  {    
    const data =  this.http.get<PagedResponseKaizen>(this.APIURL+'/Kaizen/SearchKaizens' + '?PageNumber=1&PageSize=55&criteria='+criteria + '&ShowHidden='  + JSON.stringify(hidden) +'&Email=' + email);
    return data;
  }

}